import { render } from "./change-pass-view.vue?vue&type=template&id=1607e2b8&scoped=true&ts=true"
import script from "./change-pass-view.vue?vue&type=script&lang=ts"
export * from "./change-pass-view.vue?vue&type=script&lang=ts"

import "./change-pass-view.vue?vue&type=style&index=0&id=1607e2b8&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1607e2b8"]])

export default __exports__